import styled from 'styled-components'

export default styled.div`
  .__react_component_tooltip:not(.react-tooltip-simple) {
    padding: 0 !important;
    background: ${props => props.theme.cardBackground} !important;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1) !important;
    border-radius: 10px !important;
    border: none;
    z-index: 2147483645;

    &.place-left {
      &:before {
        border-left: ${props => props.theme.tooltipBorder} !important;
      }

      &:after {
        border-left-color: ${props => props.theme.cardBackground} !important;
      }
    }

    &.place-top {
      &:before {
        border-top: ${props => props.theme.tooltipBorder} !important;
      }

      &:after {
        border-top-color: ${props => props.theme.cardBackground} !important;
      }
    }

    &.place-bottom {
      &:before {
        border-bottom: ${props => props.theme.tooltipBorder} !important;
      }

      &:after {
        border-bottom-color: ${props => props.theme.cardBackground} !important;
      }
    }

    &.place-right {
      &:before {
        border-right: ${props => props.theme.tooltipBorder} !important;
      }

      &:after {
        border-right-color: ${props => props.theme.cardBackground} !important;
      }
    }
  }
`
